/**
 * Formats the amount to the 1st non-zero digit: if the amount is more or equal to 0.01 - it returns x.xx,
 * otherwise - it turns the value with the 1st non-zero digit, ex. 0.00003.
 *
 * @param {number} amount
 * @return {string}
 */
export default (amount) => {
    if (typeof amount !== 'number') {
        amount = Number(amount);
    }
    if (amount === 0) {
        return '0.00';
    }
    if (amount >= 0.01) {
        return amount.toFixed(2);
    } else {
        const pos = Math.floor(Math.log10(amount));
        return amount.toFixed(Math.abs(pos) + 1);
    }
};
